import { createApp } from 'vue'

import { install } from '@/bootstrap'

import App from '@/components/App.vue'

install(createApp(App), true).mount('#app')
